<template>
    <DModal
        is-confirm
        is-small
        is-error
        :title="__('customers.customers.cloudpit_disable_2fa_modal_title')"
        :message="__('customers.customers.cloudpit_disable_2fa_modal_message')"
        :show="showModal"
        @confirm="confirm"
        @close="close"
    />
</template>

<script setup>
defineProps({
    showModal: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['confirm', 'close'])

function confirm () {
    emit('confirm')
}
function close () {
    emit('close')
}
</script>
